import {injectable} from "inversify";
import {LeagueDivision} from "@/modules/competitions/entity";
import {Team} from "@/modules/team/entity";
import {Season} from "@/modules/season/entity";
import {TableStatistics} from "@/modules/competitions/entity/TableStatistics";

@injectable()
export default class DivisionTableStatisticsGenerator {
  async generate(season: Season, division: LeagueDivision) {
    await division.load('teams');

    await division.teams.forEachAsync(async (team: Team) => {
      const stats = new TableStatistics();
      stats.team = team;
      stats.season = season;
      stats.division = division;

      await stats.save();
    });
  }
}